function setSession(key, value, ttl) {
	const now = new Date();
	const item = {value: value,expiry: now.getTime() + ttl};
	localStorage.setItem(key, JSON.stringify(item));
    //console.log("set Session",JSON.stringify(item));
}

function getSession(key) {
	const itemStr = localStorage.getItem(key);

	if (!itemStr) {
		return null;
	}
	const item = JSON.parse(itemStr);
	const now = new Date();

	if (now.getTime() > item.expiry) {
		localStorage.removeItem(key)
		return null
	}
   // console.log("getSession", item.value);
	return item.value;
}
const sessions = {
    setSession,
    getSession
}
export default sessions;